import React from "react";

import style from "../../assets/css/components/Button/Button.module.css";

function Button({ text, type, ...rootDOMAttributes }) {
  return (
    <button
      type={type ? type : "submit"}
      className={style.btnForm}
      {...rootDOMAttributes}
    >
      {text}
    </button>
  );
}

export default Button;
